const triggerChatFlow = (message) => {
  try {
    const $zoho = window.$zoho;
    if ($zoho && $zoho.salesiq && $zoho.salesiq.floatwindow) {
      // Open Zoho SalesIQ chat window
      $zoho.salesiq.floatwindow.visible('show');

      // Prefill the chat input if API is available
      if (
        message &&
        $zoho.salesiq.chat &&
        typeof $zoho.salesiq.chat.messagehint === 'function'
      ) {
        try {
          $zoho.salesiq.chat.messagehint(message);
        } catch (_) {
          // Non-blocking
        }
      } else if (
        message &&
        $zoho.salesiq.visitor &&
        typeof $zoho.salesiq.visitor.addInfo === 'function'
      ) {
        // Fallback: attach a note/info for the agent with the user's intent
        try {
          $zoho.salesiq.visitor.addInfo('Richiesta', message);
        } catch (_) {
          // Non-blocking
        }
      }
    }
  } catch (_) {
    // Non-blocking
  }
};

export default triggerChatFlow;
